<template>
	<TwoColumns
		columns-order="flex-col lg:flex-row"
		first-column-class="items-center flex"
		:second-column-class="hasContainedWithin ? 'contained-section' : ''"
	>
		<template #first>
			<CarbarImage
				image="img/business/employee-benefits/hero-novatedsubs.webp"
				alt-text="What is an all-inclusive car subscription?"
			/>
		</template>
		<template #second>
			<div>
				<h2>What is an all-inclusive car subscription?</h2>
				<div class="space-y-5">
					<p>
						A car subscription service takes all the variable and
						unexpected costs of traditional car ownership and rolls
						it up into a simple, convenient weekly subscription.
					</p>
					<p>
						The car is yours for as long as you subscribe to it and
						you can stop or swap anytime with 2 weeks notice. All
						you need to worry about is tolls, fuel - or charging if
						you choose an
						<CarbarLink
							href="/electric-vehicles"
							font-size="text-lg"
							text-color="text-gray-575"
							text="electric, or EV car subscription"
						/>
						<span>*.</span>
					</p>
					<p>
						Take the hassle, stress and uncertainty out of having a
						car and subscribe online today.
					</p>
				</div>
				<DoubleCta class="mt-8" :is-stacked="false">
					<template #primary>
						<CarbarLink
							:underline="false"
							class="w-full md:min-w-fit"
							href="/cars/subscribe"
						>
							<CarbarButton>
								Search and subscribe cars online
							</CarbarButton>
						</CarbarLink>
					</template>
					<template #secondary>
						<CarbarLink
							:underline="false"
							class="w-full md:min-w-fit"
							href="/car-subscription"
						>
							<CarbarButton :is-outline="true">
								Learn more about car subscription
							</CarbarButton>
						</CarbarLink>
					</template>
				</DoubleCta>
				<div class="mt-8">
					<TermsAndConditions :is-full-width="false">
						* The subscription cost excludes tolls, fuel and
						infringements.
						<CarbarLink
							href="/terms-and-conditions/car-subscription"
							target="_blank"
							class="text-xsm"
							text="Terms and conditions"
						/>
						apply.
					</TermsAndConditions>
				</div>
			</div>
		</template>
	</TwoColumns>
</template>

<script setup>
import TwoColumns from '@/components/sections/TwoColumns.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import DoubleCta from '@/components/buttons/DoubleCta.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'

defineProps({
	hasContainedWithin: {
		type: Boolean,
		default: true,
		required: false,
	},
})
</script>
